export function getDefaultEventDateRange(referenceDate = new Date()) {
  const startDate = new Date(referenceDate);
  startDate.setHours(0, 0, 0, 0);

  const endDate = new Date(referenceDate);
  endDate.setMonth(endDate.getMonth() + 6);
  endDate.setHours(23, 59, 59, 999);

  return { startDate, endDate };
}

export function getEventDateValue(event) {
  const raw = event?.eventDate ?? event?.EventDate;
  if(raw == null || raw === ''){
    return null;
  }
  const eventDate = new Date(raw);
  return Number.isNaN(eventDate.getTime()) ? null : eventDate;
}

/** Upcoming soonest-first, then past most-recent-first. */
export function sortEventsForList(events, referenceDate = new Date()) {
  const now = referenceDate.getTime();

  return [...(events || [])].sort((a, b) => {
    const dateA = getEventDateValue(a);
    const dateB = getEventDateValue(b);
    if(!dateA && !dateB) return 0;
    if(!dateA) return 1;
    if(!dateB) return -1;

    const timeA = dateA.getTime();
    const timeB = dateB.getTime();
    const aUpcoming = timeA >= now;
    const bUpcoming = timeB >= now;
    if(aUpcoming !== bUpcoming){
      return aUpcoming ? -1 : 1;
    }
    return aUpcoming ? timeA - timeB : timeB - timeA;
  });
}

export function isEventCategoryFilterActive(selectedCategoryIds, allCategoryIds) {
  return selectedCategoryIds.length > 0
    && selectedCategoryIds.length < allCategoryIds.length;
}

export function isEventProgramFilterActive(selectedProgramIds, allProgramIds) {
  return selectedProgramIds.length > 0
    && selectedProgramIds.length < allProgramIds.length;
}

/** Match checkbox selection (documentId) against nested relations that may still expose numeric id. */
export function relationMatchesSelection(selectedIds, relation) {
  if(!relation || !selectedIds?.length){
    return false;
  }
  const selected = new Set(selectedIds.map(String));
  return [relation.documentId, relation.id]
    .filter(v => v != null)
    .some(candidate => selected.has(String(candidate)));
}

export function getDefaultEventFilterState({
  categories = [],
  programs = [],
  programFromUrl = null,
  referenceDate = new Date(),
} = {}) {
  const allCategoryIds = categories.map(item => item.id);
  const allProgramIds = programs.map(item => item.id);
  const { startDate, endDate } = getDefaultEventDateRange(referenceDate);

  return {
    selectedCategory: allCategoryIds,
    selectedProgram: programFromUrl ? [programFromUrl] : allProgramIds,
    startDate,
    endDate,
  };
}

export function getFilteredEvents(
  events,
  value,
  selectedCategory,
  selectedProgram,
  startDate,
  endDate,
  allCategoryIds = [],
  allProgramIds = [],
) {
  const categoryFilterActive = isEventCategoryFilterActive(selectedCategory, allCategoryIds);
  const programFilterActive = isEventProgramFilterActive(selectedProgram, allProgramIds);
  const searchQuery = (value || '').trim();

  return (events || []).filter(event => {
    if(searchQuery && !event.title.toLowerCase().includes(searchQuery.toLowerCase())){
      return false;
    }
    if(programFilterActive){
      if(!relationMatchesSelection(selectedProgram, event.program)){
        return false;
      }
    }
    if(categoryFilterActive){
      if(!relationMatchesSelection(selectedCategory, event.category)){
        return false;
      }
    }
    if(startDate){
      if(!event.eventDate){
        return false;
      }
      const eventDate = new Date(event.eventDate);
      if(Number.isNaN(eventDate.getTime())){
        return false;
      }
      if(eventDate < startDate){
        return false;
      }
    }
    if(endDate){
      if(!event.eventDate){
        return false;
      }
      const eventDate = new Date(event.eventDate);
      if(Number.isNaN(eventDate.getTime())){
        return false;
      }
      if(eventDate > endDate){
        return false;
      }
    }
    return true;
  });
}
